import React from 'react';

import './IconButton.css';

export interface IconButtonProps {
  type?: 'button' | 'submit';
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  /** Shown to assistive tech (required for icon-only buttons). */
  'aria-label': string;
  title?: string;
}

/**
 * Accessible icon-only control. Default styling is neutral greyscale for
 * secondary actions (edit, overflow, etc.).
 */
const IconButton: React.FC<IconButtonProps> = ({
  type = 'button',
  children,
  onClick,
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
  title,
}) => {
  return (
    <button
      type={type}
      className={`icon-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title ?? ariaLabel}
    >
      {children}
    </button>
  );
};

export default IconButton;
